import ProductBase from './productBase.js';
import fetchJsonp from 'fetch-jsonp';
import qs from 'qs';


export default class VM extends ProductBase {
  buyUrl = 'https://ecs-buy.aliyun.com/buyRedirect';
  orderUrl = 'https://ecs-buy.aliyun.com/#/order/prepay'

  match(code) {
    return code === 'vm';
  }

  getDefaultConfig() {
    return {
      orderType: 'instance-buy',
      chargeType: 'PrePaid',
      commodity: {
        autoRenew: true,
        dataDisks: [], //数据盘
        zoneId: 'random', //可用区
        vpcId: '', //可选
        // priceUnit: 'Month',
        // maxAmount: 1, //购买台数
        amount: 1 //购买台
        // imageType: 'public'
      }
    };
  }

  setPeroid(config, number, type) {
    if (number == 7 && type == 'day') {
      number = 1;
    }

    const TimeTypeMap = {
      //  时间类型映射
      'Day': 'Weekly',
      'Month': 'Monthly',
      'Year': 'Yearly'
    };

    config.commodity.priceUnit = type;
    config.commodity.periodType = TimeTypeMap[type];
    config.commodity.period = number;
  }

  getConfig(commodityValue) {
    let me = this;
    commodityValue = commodityValue || me.commodityValue;
    let config = me.getDefaultConfig();

    config.regionId = commodityValue.vm_region_no;
    config.commodityCode = me.accessories.commodityCode;

    Object.assign(config.commodity, {
      regionId: commodityValue.vm_region_no,
      networkType: commodityValue.vm_web_type,
      instanceType: commodityValue.instance_type, //实例
      internetChargeType: commodityValue.vm_bandwidth.internetChargeType,
      internetMaxBandwidthOut: commodityValue.vm_bandwidth.internetMaxBandwidthOut,
      systemDiskSize: commodityValue.systemdisk.systemDiskSize,
      systemDiskCategory: commodityValue.systemdisk.systemDiskCategory,
      ioOptimized: commodityValue.ioOptimized,
      imageId: commodityValue.vm_os,
      imageType: commodityValue.imageType,
      zoneId: commodityValue.zoneId,
      dataDisks: commodityValue.datadisk,
      amount: this.formatQuantity(commodityValue)
    });

    //判断是否需要设置镜像，目前暂时用imageType是否有值来约束
    
    // me.addDependencies(function(){
    //   if (me.config.imageId && me.config.imageId.indexOf('.vhd') === -1) {
    //     return new Promise((resolve) => {
    //         //设置镜像Id
    //         setImageID(me.config, resolve);
    //       });
    //   }
    // });
    if (config.commodity.imageId && config.commodity.imageId.indexOf('.vhd') === -1) {
      this.addDependencies(new Promise((resolve) => {
        //设置镜像Id
        setImageID(config, resolve);
      }));
    }

    return config;

  }

  getBuyConfig() {
    return Object.assign({}, this.config.commodity, {
      activityId: this.activityId
    });
  }

  getOrderConfig() {
    let commodityValue = {
      'vm_region_no': this.commodityValue.vm_region_no,
      'vm_iz': 'random',
      'networkType': 'vpc',
      'instance_type': [{
        'instance_type': this.commodityValue.instance_type,
        'instance_generation': 'ecs-3'
      }],
      'vm_web_type': '1',
      'iooptimized': 'optimized',
      'vm_bandwidth': [{
        'vm_bandwidth': this.commodityValue.vm_bandwidth.internetMaxBandwidthOut * 1024,
        'vm_is_flow_type': '5'
      }],
      'vm_os': [{
        'vm_os': this.config.commodity.imageId,
        'vm_os_kind': '',
        'vm_os_bit': ''
      }],
      'systemdisk': [{
        'systemdisk_category': this.commodityValue.systemdisk.systemDiskCategory,
        'systemdisk_size': this.commodityValue.systemdisk.systemDiskSize,
        'systemdisk_device': '/dev/xvda'
      }],
      'datadisk': null,
      'zoneId': 'random'
    };

    const orderConfig = {
      data: {
        quantity: this.commodityValue.order_num,
        duration: this.config.commodity.period,
        pricingCycle: this.config.commodity.priceUnit,
        activityId: this.activityId
      },
      components: commodityValue
    };
    return {
      orderData: [orderConfig]
    };
  }
}

function setImageID(config, resolve) {
  let commodity = config.commodity;

  let params = {
    chargeType: config.PrePaid,
    instanceType: commodity.instanceType,
    isSupportIoOptimized: commodity.ioOptimized,
    imageOwnerAlias: 'system',
    regionId: commodity.regionId,
    pageSize: 100,
    pageNumber: 1,
    '$$namespace': 'ecs-buy'
  };

  fetchJsonp('https://ecs-buy.aliyun.com/api/ecsImage/describeImages.jsonp?' + qs.stringify(params))
    // fetchJsonp('https://ecs-buy.aliyun.com/api/ecsImage/describeImages.jsonp?', params)
    .then(function (response) {
      return response.json();
    }).then((data) => {
      if (data && data.code == '200' && data.data) {
        let images = data.data.Images.Image;

        let image = images.find((item) => {
          return item.OSName == commodity.imageId;
        });

        if (image) {
          commodity.imageId = image.ImageId;
        }

        resolve(config);
      }

    }).catch((err) => {
      console.error(err);
    });
}


// WEBPACK FOOTER //
// ./lib/services/product/vm.js